var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline"
    },
    height: "1.5em",
    viewBox: "0 -960 960 960",
    width: "1.5em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M690.85-536.16H269.77L255-426.92h450.38l-14.53-109.24ZM176.54-179.62l48.23-356.54h-91.69q-16.54 0-26.31-13.3-9.77-13.31-5.54-29.23l52-181.16q3.23-11.07 11.69-17.73 8.47-6.65 20.16-6.26h590.23q11.69 0 20.15 6.65 8.46 6.65 11.69 17.73l52 180.77q4.23 15.92-5.54 29.23-9.77 13.3-26.3 13.3h-91.47l47.62 356.54h-45l-27.38-201.92H248.92l-27.38 201.92h-45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.94aa332ca2163ac5aee8c34d2ad9c691.svg";
export { ForwardRef as ReactComponent };